import React, { useCallback } from 'react';

import { UpdateLifestylesSetCacheAction } from '../../../../../../lifestylesSets/lifestylesSetsTypes';
import { ClassName } from '../../../../../../../types';
import { SelectedLifestylesSidebarPopoverClearButtonLifestylesSet } from './SelectedLifestylesSidebarPopoverClearButton.types';

import { useEmptyLifestylesSet } from '../../../../../../lifestylesSets/hooks/useEmptyLifestylesSet';

import { useToastNotification } from '../../../../../../../common/hooks/useToastNotification';

import { PureButtonHelper } from '../../../../../../../helpers/buttons/PureButtonHelper';

import { parseRequestError } from '../../../../../../../utils/parseRequestError';

import { words } from '../../../../../../../locales/keys';

import { LifestylesSetCache } from '../../../../../../lifestylesSets/LifestylesSetCache';

interface SelectedLifestylesSidebarPopoverClearButtonProps {
  lifestylesSet: SelectedLifestylesSidebarPopoverClearButtonLifestylesSet;
  onClose: () => void;
  updateLifestylesSetCache: UpdateLifestylesSetCacheAction<SelectedLifestylesSidebarPopoverClearButtonLifestylesSet>;
  className?: ClassName;
}

function SelectedLifestylesSidebarPopoverClearButton({
  lifestylesSet,
  onClose,
  updateLifestylesSetCache,
  className
}: SelectedLifestylesSidebarPopoverClearButtonProps) {
  const uuid = lifestylesSet?.uuid;

  const { emptyLifestylesSetLoading, emptyLifestylesSet } =
    useEmptyLifestylesSet({
      itemCacheKey: LifestylesSetCache.showCacheKey(),
      updateLifestylesSetCache
    });

  const { showToastNotification } = useToastNotification({
    appearance: 'error'
  });

  const handleEmptyLifestylesSet = useCallback(() => {
    uuid &&
      emptyLifestylesSet({ uuid }).catch((error) => {
        showToastNotification(parseRequestError(error));
      });
    onClose();
  }, [uuid, emptyLifestylesSet, onClose, showToastNotification]);

  return (
    <PureButtonHelper
      className={
        className ||
        'font-medium hover:bg-gray-200 items-center px-4 py-2 rounded-md text-gray-700 text-sm dark:hover:bg-gray-700 dark:text-gray-300 focus:ring-offset-0'
      }
      dataGa="selected-lifestyles-set-clear-button"
      i18nText={words.clearSelection}
      disabled={emptyLifestylesSetLoading}
      onClick={handleEmptyLifestylesSet}
    />
  );
}

export default SelectedLifestylesSidebarPopoverClearButton;
